import 'es6-promise/auto';
import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import * as fetch from 'isomorphic-fetch';
import { IEventCourseBlock,MultipleLocationsModel } from '../classes'

interface IEventCourseContanerState {
    MultipleLocationList: Array<IEventCourseBlock>;
    selectedRapattoniID: string;
    isLoggedIn: boolean;
    loginPageUrl: string;
    noAvailabilityMessage: string;
    registerButtonText: string;
    isMemberOnly: boolean;
    multipleLocationDefaultMessage: string;
    locationFormat: string;
    price: number;
}

class EventCourseContainer extends React.Component<any, IEventCourseContanerState>{

    constructor() {
        var bootstrapData = (window as any).bootStrappedData as MultipleLocationsModel;
        var loggedIn = (window as any).isLoggedIn as boolean;
        var loginPageUrl = (window as any).loginPageUrl as string;
        var IsMemberOnly = bootstrapData.isMemberOnly;
        var noAvailabilityMessage = bootstrapData.noAvailablilityMessage;
        var multipleLocationDefaultMessage = bootstrapData.multipleLocationDefaultMessage;
        var registerButtonText = bootstrapData.registerButtonText || "Register";
        if (bootstrapData == undefined) {
            return;
        }
        super()
        this.state = {
            MultipleLocationList: bootstrapData.locationViewModels,
            selectedRapattoniID: "-1",
            isLoggedIn: loggedIn ,
            loginPageUrl: loginPageUrl,
            noAvailabilityMessage: noAvailabilityMessage,
            registerButtonText: registerButtonText,
            isMemberOnly: IsMemberOnly,
            multipleLocationDefaultMessage: multipleLocationDefaultMessage,
            locationFormat: "",
            price: bootstrapData.price
        }
    }

    

    locationChange(e: any): void {
        var rapattoniId = e.target.value;
        var buttonElement = document.getElementById("multiple-location-button");
        buttonElement.innerHTML = "";
        this.setState({
            selectedRapattoniID: rapattoniId
        });
        if (rapattoniId === "-1") {
            return;
        }
        var redirectUrl = "";
        var selectedEvent = this.state.MultipleLocationList.filter(x => x.locationRapattoniID == rapattoniId)[0] as IEventCourseBlock;
        var cartUrl = "/cart?EventId=" + rapattoniId;
        if (this.state.isMemberOnly && !this.state.isLoggedIn)
            redirectUrl = this.state.loginPageUrl + "?returnUrl=~" + cartUrl
        else
            redirectUrl = cartUrl;
        this.setState({
            locationFormat: selectedEvent.locationFormat
        });
        var formattedLocation = `${selectedEvent.locationName} - ${selectedEvent.streetAddress}, ${selectedEvent.state}, ${selectedEvent.zipcode}`;
        var locSpan = document.getElementById("addToCalendarLoc");
        locSpan.textContent = formattedLocation;
        this.renderButtonElement(selectedEvent, redirectUrl);

    }

    renderButtonElement(eventBlock: IEventCourseBlock, redirectUrl: string): void{
        var buttonElement = document.getElementById("multiple-location-button");
        if(buttonElement != undefined){
            var htmlElement = "";
            if (!eventBlock.availability)
                htmlElement = this.state.noAvailabilityMessage;
            else {

                htmlElement = '<a href="'+redirectUrl+'" class="btn">' + this.state.registerButtonText + '</a>';
            }
            buttonElement.innerHTML = htmlElement;
        }
    }

    IsEmpty(str: string): boolean {
        return !str || str.length === 0;
    }
    // To fix null being sent as query value to maps API
    createMapLocationPath(event: IEventCourseBlock): string {
        let mapLocation = '';
        if (event.streetAddress != null)
            mapLocation += event.streetAddress + ',';
        if (event.city != null)
            mapLocation += event.city + ',';
        if (event.state != null)
            mapLocation += event.state + ',';
        if (event.zipcode != null)
            mapLocation += event.zipcode;
        return mapLocation;
    }


    displayMapsAndAddressFields(events: IEventCourseBlock[]): boolean {
        let selectedRapattoniBlock = this.state.MultipleLocationList.filter((x) => x.locationRapattoniID == this.state.selectedRapattoniID)[0];
        if (selectedRapattoniBlock != undefined) {
            if (selectedRapattoniBlock.locationFormat == "Self-Study")
                return false;
            if (selectedRapattoniBlock.locationFormat == "Live Stream" && !(!this.IsEmpty(selectedRapattoniBlock.streetAddress) || !this.IsEmpty(selectedRapattoniBlock.city))) {
                return false;
            }
        }
        return true;
    }
    render() {
        return (
            <div>
                <div>
                    {
                        <select value={this.state.selectedRapattoniID} className="course-details-dropdown" onChange={this.locationChange.bind(this)} >
                            <option selected value="-1"  > Select a location</option>
                            ({this.state.MultipleLocationList.map((location, index) => {
                                return (
                                    location.city == null ?
                                        <option selected value={location.locationRapattoniID}>{location.locationFormat}</option>
                                        : <option selected value={location.locationRapattoniID}>{location.city} &#8226; {location.locationFormat}</option>
                                );
                            })
                            })
                        </select>
                    }
                    {
                        this.state.selectedRapattoniID === "-1" ? 
                            <p>{this.state.multipleLocationDefaultMessage}</p>
                            : <div></div>
                    }
                </div>
                <div>
                    {
                        this.state.selectedRapattoniID !== "-1" && this.displayMapsAndAddressFields(this.state.MultipleLocationList) ?
                            (this.state.MultipleLocationList
                                .filter((sel) => sel.locationRapattoniID ==
                                    this.state.selectedRapattoniID).map((selectedLocation) => {
                                        return (
                                            <div>
                                                <p>{selectedLocation.locationName} {selectedLocation.classRoom}</p>
                                                <p>{selectedLocation.streetAddress}</p>
                                                <p>{selectedLocation.city}</p>
                                                <p>{selectedLocation.state}</p>
                                                <p>{selectedLocation.zipcode}</p>
                                                {
                                                    selectedLocation.streetAddress != "" && selectedLocation.city != ""
                                                        ?
                                                        <a href={`https://maps.google.com/?q= ${this.createMapLocationPath(selectedLocation)}`} target="_blank">View Map</a>
                                                        :
                                                        <div></div>
                                                }

                                            </div>
                                        );
                                    }))
                            :
                            <div></div>
                    }
                </div>
                {this.state.selectedRapattoniID !== "-1" ?
                    <div className="course-details">
                        <h5>Format</h5>
                        <p>{this.state.locationFormat}</p>
                    </div>
                    : <div></div>
                }

            </div>
        )
    }
}

export default EventCourseContainer;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/course-event/location/course-event-container.tsx